<template>
  <el-form
    :model="form"
    :rules="rules"
    :inline="false"
    ref="form"
    label-width="140px"
    label-position="right"
    v-loading="formLoading"
    element-loading-text="提交中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 申请人信息 -->
    <el-divider content-position="left">申请信息</el-divider>
    <el-row>
      <el-col :span="8">
        <el-form-item label="报销人姓名" prop="clbxUserName">
          <el-input v-model="form.clbxUserName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="当前部门名称" prop="organName">
          <el-input v-model="form.organName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="报销时间" prop="clbxDate">
          <el-date-picker
            v-model="form.clbxDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :disabled="readonly"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="所属项目编号" prop="xmbh" v-if="userType !== '2'">
          <el-input v-model="form.xmbh" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="所属项目名称" prop="xmmc" v-if="userType !== '2'">
          <el-input v-model="form.xmmc" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="业务流水号" prop="ywlsh">
          <el-input v-model="form.ywlsh" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="办公地点" prop="bgdd">
          <el-input v-model="form.bgdd" :disabled="readonly"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否有项目经理" prop="isPm" v-if="userType !== '2'">
          <el-select v-model="form.isPm" placeholder="请选择" class="pctw100" :disabled="readonly">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有直属领导" prop="isPm" v-else>
          <el-select v-model="form.isPm" placeholder="请选择" class="pctw100" :disabled="readonly">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8" v-if="form.isPm === '1'">
        <el-form-item label="项目经理" prop="pmName" v-if="userType !== '2'">
          <el-input v-model="form.pmName" disabled></el-input>
        </el-form-item>
        <el-form-item label="直属领导" prop="pmName" v-else>
          <el-input v-model="form.pmName" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="报销金额" prop="bxAmt" class="examine-incity-amt">
          <jh-number
            :decimalNumber="2"
            placeholder="请输入报销金额"
            :isMoney="true"
            v-model="form.bxAmt"
            :disabled="readonly"
          >
            <span slot="append">元</span>
          </jh-number>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否借调" prop="isJd">
          <el-select v-model="form.isJd" placeholder="请选择" class="pctw100" :disabled="readonly">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8" v-if="form.isJd === '1'">
        <el-form-item label="借调部门名称" prop="jdOrganName">
          <el-input v-model="form.jdOrganName" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 添加抵扣相关表单字段 -->
    <el-row>
      <el-col :span="8">
        <el-form-item label="核准报销金额" prop="examineBxAmt" :class="getExamineAmtClass()">
          <jh-number
            :decimalNumber="2"
            placeholder="请输入核准报销金额"
            :isMoney="true"
            v-model="form.examineBxAmt"
            :disabled="readonly"
          >
            <span slot="append">元</span>
          </jh-number>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="借款金额" prop="jkje">
          <jh-number
            :decimalNumber="2"
            placeholder="借款金额"
            :isMoney="true"
            v-model="form.jkje"
            :disabled="true"
          >
            <span slot="append">元</span>
          </jh-number>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否抵扣" prop="isDk">
          <el-select v-model="form.isDk" placeholder="请选择" class="pctw100" :disabled="readonly">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8" v-if="form.isDk === '1'">
        <el-form-item label="抵扣金额" prop="dkje">
          <jh-number
            :decimalNumber="2"
            placeholder="请输入抵扣金额"
            :isMoney="true"
            v-model="form.dkje"
            :disabled="readonly"
          >
            <span slot="append">元</span>
          </jh-number>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 行程明细 -->
    <el-collapse v-model="activeCollapseNames">
      <el-collapse-item name="xc">
        <template slot="title">
          <div class="collapse-header">
            <span class="collapse-title">行程明细</span>
            <div class="collapse-actions">
              <el-button
                type="text"
                size="mini"
                :loading="previewingXc"
                @click.stop="previewAllXcInvoices"
                :disabled="clbxXcList.length === 0"
              >
                预览全部发票
              </el-button>
            </div>
          </div>
        </template>
        <div style="width: 100%; overflow-x: auto">
          <jh-table
            class="fg1 ova autoHeight"
            size="small"
            :stripe="true"
            row-key="clbxxcId"
            ref="xcTable"
            :columnList="xcColumnList"
            :data="clbxXcList"
            isExternal
            :disabled="true"
            :show-summary="true"
            :summary-method="getXcSummaries"
          />
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 住宿明细 -->
    <el-collapse v-model="activeCollapseNames">
      <el-collapse-item name="zs">
        <template slot="title">
          <div class="collapse-header">
            <span class="collapse-title">住宿明细</span>
            <div class="collapse-actions">
              <el-button
                type="text"
                size="mini"
                :loading="previewingZs"
                @click.stop="previewAllZsInvoices"
                :disabled="clbxZsList.length === 0"
              >
                预览全部发票
              </el-button>
            </div>
          </div>
        </template>
        <div style="width: 100%; overflow-x: auto">
          <jh-table
            class="fg1 ova autoHeight"
            size="small"
            :stripe="true"
            row-key="clbxzsId"
            ref="zsTable"
            :columnList="zsColumnList"
            :data="clbxZsList"
            isExternal
            :disabled="true"
            :show-summary="true"
            :summary-method="getZsSummaries"
          />
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 行程明细详情弹窗 -->
    <clbx-xc-cashier-dialog
      :visible.sync="xcDialogVisible"
      :ssxm-code="currentXcDetail ? currentXcDetail.xmbh : ''"
      :ssxm-name="currentXcDetail ? currentXcDetail.xmmc : ''"
      :edit-data="currentXcDetail"
      :readonly="true"
      :userType="userType !== '2'"
      :finance="finance"
      @financeSubmitSuccess="handleFinanceSubmitSuccess"
      append-to-body
    />

    <!-- 住宿明细详情弹窗 -->
    <clbx-zs-dialog
      :visible.sync="zsDialogVisible"
      :ssxm-code="currentZsDetail ? currentZsDetail.xmbh : ''"
      :ssxm-name="currentZsDetail ? currentZsDetail.xmmc : ''"
      :edit-data="currentZsDetail"
      :readonly="true"
      :userType="userType !== '2'"
      :finance="finance"
      :showAgainAdd="false"
      append-to-body
    />
  </el-form>
</template>

<script>
import dayjs from 'dayjs';
import ClbxXcCashierDialog from '../views/cwgl/clbx/components/ClbxXcCashierDialog.vue';
import ClbxZsDialog from '../views/cwgl/clbx/components/ClbxZsDialog.vue';
import { bigDecimal as BigDecimal } from 'js-big-decimal';

export default {
  name: 'ClbxApprove',
  components: {
    ClbxXcCashierDialog,
    ClbxZsDialog
  },
  props: {
    // 是否只读模式
    readonly: {
      type: Boolean,
      default: false
    },
    // 是否首次加载
    isfirst: {
      type: Boolean,
      default: true
    },
    // 是否可编辑
    edit: {
      type: Boolean,
      default: true
    },
    // 实例ID
    instanceId: {
      type: String,
      default: ''
    },
    // 用户类型
    userType: {
      type: String,
      default: '3'
    },
    // 是否为财务模式
    finance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        clbxUserName: '',
        clbxDate: dayjs().format('YYYY-MM-DD'),
        organCode: '',
        organName: '',
        isJd: '0',
        jdOrganCode: '',
        jdOrganName: '',
        xmbh: '',
        xmmc: '',
        bxAmt: 0,
        hzbxAmt: 0,
        isPm: '0',
        pmId: '',
        pmName: '',
        ywlsh: '',
        bgdd: '',
        ssxmName: '',
        ssxmCode: '',
        jkje: 0,
        isDk: '0',
        dkje: 0,
        bxDkStatus: '01',
        examineBxAmt: 0
      },
      clbxXcList: [],
      clbxZsList: [], // Added clbxZsList
      xcDialogVisible: false,
      zsDialogVisible: false, // Added zsDialogVisible
      currentXcDetail: null,
      currentZsDetail: null, // Added currentZsDetail
      // 折叠面板控制
      activeCollapseNames: ['xc', 'zs'], // 控制折叠面板的展开状态
      previewingXc: false, // 行程明细预览发票加载状态
      previewingZs: false, // 住宿明细预览发票加载状态
      rules: {
        bxAmt: [{ required: true, message: '请输入报销金额', trigger: 'blur' }],
        xmbh: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
        jdOrganCode: [{ required: true, message: '请选择借调部门', trigger: 'change' }],
        pmId: [{ required: true, message: '请选择项目经理', trigger: 'change' }]
      },
      formLoading: false,
      // 行程明细表格列配置
      xcColumnList: [
        {
          type: 'index',
          align: 'center',
          width: '50px'
        },
        {
          prop: 'startDate',
          label: '起始日期',
          align: 'center',
          minWidth: '100px',
          render: (h, scope) => {
            return h('div', {}, [this.formatDate(scope.row.startDate)]);
          }
        },
        {
          prop: 'startTime',
          label: '起始时间',
          align: 'center',
          minWidth: '80px'
        },
        {
          prop: 'startAdd',
          label: '起始地点',
          align: 'center',
          minWidth: '80px'
        },
        {
          prop: 'endDate',
          label: '结束日期',
          align: 'center',
          minWidth: '100px',
          render: (h, scope) => {
            return h('div', {}, [this.formatDate(scope.row.endDate)]);
          }
        },
        {
          prop: 'endTime',
          label: '结束时间',
          align: 'center',
          minWidth: '80px'
        },
        {
          prop: 'endAdd',
          label: '目的地',
          align: 'center',
          minWidth: '80px'
        },
        {
          prop: 'xcTs',
          label: '天数',
          align: 'center',
          minWidth: '60px'
        },
        {
          label: '交通费',
          align: 'center',
          children: [
            {
              prop: 'airAmt',
              label: '飞机',
              headerAlign: 'center',
              align: 'right',
              minWidth: '80px',
              render: (h, scope) => {
                return h('div', {}, [`${scope.row.airAmt}`]);
              }
            },
            {
              prop: 'trainAmt',
              label: '火车',
              headerAlign: 'center',
              align: 'right',
              minWidth: '80px',
              render: (h, scope) => {
                return h('div', {}, [`${scope.row.trainAmt}`]);
              }
            },
            {
              prop: 'otherAmt',
              label: '其他',
              headerAlign: 'center',
              align: 'right',
              minWidth: '80px',
              render: (h, scope) => {
                return h('div', {}, [`${scope.row.otherAmt}`]);
              }
            },
            {
              prop: 'inCityAmt',
              label: '市内交通',
              headerAlign: 'center',
              align: 'right',
              minWidth: '80px',
              render: (h, scope) => {
                return h('div', {}, [`${scope.row.inCityAmt}`]);
              }
            },
            {
              prop: 'examineInCityAmt',
              label: '核准市内交通',
              headerAlign: 'center',
              align: 'right',
              minWidth: '120px',
              render: (h, scope) => {
                const examineInCityAmt = parseFloat(scope.row.examineInCityAmt || 0);
                const inCityAmt = parseFloat(scope.row.inCityAmt || 0);
                const isDifferent = examineInCityAmt !== inCityAmt;

                return h(
                  'div',
                  {
                    style: {
                      backgroundColor: isDifferent ? '#e8f5e8' : 'transparent',
                      padding: '4px',
                      borderRadius: '4px'
                    }
                  },
                  [`${examineInCityAmt}`]
                );
              }
            }
          ]
        },
        {
          prop: 'btAmt',
          label: '申请补贴',
          headerAlign: 'center',
          align: 'right',
          minWidth: '80px',
          render: (h, scope) => {
            return h('div', {}, [`${scope.row.btAmt}`]);
          }
        },
        {
          prop: 'examineBtAmt',
          label: '核准补贴',
          headerAlign: 'center',
          align: 'right',
          minWidth: '80px',
          render: (h, scope) => {
            const examineBtAmt = parseFloat(scope.row.examineBtAmt || 0);
            const btAmt = parseFloat(scope.row.btAmt || 0);
            const isDifferent = examineBtAmt !== btAmt;

            return h(
              'div',
              {
                style: {
                  backgroundColor: isDifferent ? '#e8f5e8' : 'transparent',
                  padding: '4px',
                  borderRadius: '4px'
                }
              },
              [`${examineBtAmt}`]
            );
          }
        },
        {
          prop: 'ssxmName',
          label: '所属项目',
          align: 'center',
          minWidth: '150px'
        },
        {
          prop: 'zmjjrRemark',
          label: '周末节假日说明',
          align: 'center',
          minWidth: '150px'
        },
        {
          prop: 'tsfyRemark',
          label: '特殊费用说明',
          align: 'center',
          minWidth: '150px'
        },

        {
          prop: 'fpList',
          label: '发票数量',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100px',
          fixed: 'right',
          render: (h, scope) => {
            return h(
              'el-button',
              {
                props: {
                  type: 'text',
                  size: 'mini',
                  disabled: !scope.row.fpList || scope.row.fpList.length === 0
                },
                on: {
                  click: () => this.previewAllInvoices(scope.row.fpList)
                }
              },
              [`${scope.row.fpList ? scope.row.fpList.length : 0}张`]
            );
          }
        },
        {
          prop: 'fpList',
          label: '发票总金额',
          headerAlign: 'center',
          align: 'right',
          minWidth: '120px',
          fixed: 'right',
          render: (h, scope) => {
            const fpTotalAmt = this.calculateInvoiceTotalAmount(scope.row.fpList);
            return h('div', {}, [`${fpTotalAmt}`]);
          }
        },
        {
          prop: 'totalAmt',
          label: '总金额',
          headerAlign: 'center',
          align: 'right',
          minWidth: '120px',
          fixed: 'right',
          render: (h, scope) => {
            const totalAmt = this.sumTotalAmt(scope.row);
            scope.row.totalAmt = totalAmt;
            return h('div', {}, [`${totalAmt}`]);
          }
        },
        {
          prop: '',
          label: '操作',
          align: 'center',
          minWidth: '100px',
          fixed: 'right',
          render: (h, scope) => {
            return h('div', {}, [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                    size: 'mini'
                  },
                  on: {
                    click: () => this.showXcDetail(scope.row)
                  }
                },
                '详情'
              )
            ]);
          }
        }
      ],
      // 住宿明细表格列配置
      zsColumnList: [
        {
          type: 'index',
          align: 'center',
          width: '50px'
        },
        {
          prop: 'startDate',
          label: '开始日期',
          align: 'center',
          minWidth: '120px',
          render: (h, scope) => {
            return h('div', {}, [this.formatDate(scope.row.startDate)]);
          }
        },
        {
          prop: 'endDate',
          label: '结束日期',
          align: 'center',
          minWidth: '120px',
          render: (h, scope) => {
            return h('div', {}, [this.formatDate(scope.row.endDate)]);
          }
        },
        {
          prop: 'city',
          label: '住宿城市',
          align: 'center',
          minWidth: '120px'
        },
        {
          prop: 'zsTs',
          label: '住宿天数',
          align: 'center',
          minWidth: '100px'
        },
        {
          prop: 'zsAmt',
          label: '住宿金额',
          headerAlign: 'center',
          align: 'right',
          minWidth: '120px',
          render: (h, scope) => {
            return h('div', {}, [`${scope.row.zsAmt}`]);
          }
        },
        {
          prop: 'zsPrice',
          label: '单价',
          headerAlign: 'center',
          align: 'right',
          minWidth: '120px',
          render: (h, scope) => {
            return h('div', {}, [`${scope.row.zsPrice}`]);
          }
        },
        {
          prop: 'ssxmName',
          label: '所属项目',
          align: 'center',
          minWidth: '150px'
        },
        {
          prop: 'fpList',
          label: '发票数量',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100px',
          fixed: 'right',
          render: (h, scope) => {
            return h(
              'el-button',
              {
                props: {
                  type: 'text',
                  size: 'mini',
                  disabled: !scope.row.fpList || scope.row.fpList.length === 0
                },
                on: {
                  click: () => this.previewAllInvoices(scope.row.fpList)
                }
              },
              [`${scope.row.fpList ? scope.row.fpList.length : 0}张`]
            );
          }
        },
        {
          prop: '',
          label: '操作',
          align: 'center',
          minWidth: '100px',
          fixed: 'right',
          render: (h, scope) => {
            return h('div', {}, [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                    size: 'mini'
                  },
                  on: {
                    click: () => this.showZsDetail(scope.row)
                  }
                },
                '详情'
              )
            ]);
          }
        }
      ],
      // 发票内容表格列配置
      fpColumnList: [
        {
          prop: 'fpNumber',
          label: '发票号码',
          align: 'center',
          minWidth: '150px'
        },
        {
          prop: 'fpTypeName',
          label: '发票类型',
          align: 'center',
          minWidth: '120px'
        },
        {
          prop: 'kpDate',
          label: '开票日期',
          align: 'center',
          minWidth: '120px',
          render: (h, scope) => {
            return h(
              'span',
              {},
              scope.row.kpDate ? dayjs(scope.row.kpDate).format('YYYY-MM-DD') : '-'
            );
          }
        },
        {
          prop: 'fpAmt',
          label: '金额',
          align: 'center',
          minWidth: '120px',
          render: (h, scope) => {
            return h('div', {}, [`${scope.row.fpAmt}`]);
          }
        },
        {
          prop: 'gfName',
          label: '购方名称',
          align: 'center',
          minWidth: '200px'
        },
        {
          prop: '',
          label: '操作',
          align: 'center',
          minWidth: '120px',
          fixed: 'right',
          render: (h, scope) => {
            return h('div', {}, [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                    size: 'mini'
                  },
                  on: {
                    click: () => this.previewInvoice(scope.row)
                  }
                },
                '预览'
              )
            ]);
          }
        }
      ]
    };
  },
  computed: {
    // 获取所有发票列表
    allInvoiceList() {
      const allInvoices = [];
      this.clbxXcList.forEach((detail, detailIndex) => {
        if (detail.fpList && detail.fpList.length > 0) {
          detail.fpList.forEach((invoice, invoiceIndex) => {
            allInvoices.push({
              ...invoice,
              detailIndex,
              invoiceIndex,
              rowClass: `detail-${detailIndex}` // 添加行样式类名
            });
          });
        }
      });
      return allInvoices;
    }
  },
  watch: {
    instanceId: {
      immediate: true,
      handler(newVal, oldVal) {
        // 仅当 instanceId 有效且变化时触发
        if (!newVal || newVal === oldVal) return;
        // 重置本地状态，避免展示旧数据
        this.resetForm();
        // 重新加载对应实例的数据
        this.initBizInfo();
      }
    }
  },

  methods: {
    // 财务保存成功后刷新页面数据
    handleFinanceSubmitSuccess() {
      // 重新初始化业务信息，刷新页面数据
      this.initBizInfo();
    },
    getFileExtensionWithDot(filename) {
      if (!filename) return '';
      const lastDotIndex = filename.lastIndexOf('.');
      return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex).toLowerCase();
    },
    // 获取核准报销金额样式类
    getExamineAmtClass() {
      const examineBxAmt = parseFloat(this.form.examineBxAmt || 0);
      const bxAmt = parseFloat(this.form.bxAmt || 0);
      return examineBxAmt !== bxAmt ? 'examine-bt-amt' : '';
    },

    // 初始化业务信息
    initBizInfo() {
      if (!this.instanceId) return;
      // 获取流程表单数据
      this.$api
        .post('/api/cwgl/clbx/flow/apply/getBizInfo', {
          instanceId: this.instanceId
        })
        .then((res) => {
          if (res.retHead && res.retHead.code === '0000000' && res.retBody) {
            // 初始化表单数据
            this.initFormData(res.retBody);
          } else {
            console.error('获取数据失败:', res.retHead?.message || '未知错误');
            this.$message.error('获取数据失败');
          }
        });
    },
    // 解析表单数据
    parseFormData(formData) {
      try {
        const data = JSON.parse(formData);
        this.initFormData(data);
      } catch (error) {
        console.error('解析表单数据失败:', error);
      }
    },

    // 初始化表单数据
    initFormData(data) {
      // 设置基本信息
      this.form = {
        clbxUserName: data.clbxUserName || this.form.clbxUserName,
        clbxDate: data.clbxDate || dayjs().format('YYYY-MM-DD'),
        organCode: data.organCode || this.form.organCode,
        organName: data.organName || this.form.organName,
        isJd: data.isJd || '0',
        jdOrganCode: data.jdOrganCode || '',
        jdOrganName: data.jdOrganName || '',
        xmbh: data.xmbh || '',
        xmmc: data.xmmc || '',
        bxAmt: data.bxAmt || 0,
        hzbxAmt: data.hzbxAmt || 0,
        isPm: data.isPm || '0',
        pmId: data.pmId || '',
        pmName: data.pmName || '',
        ywlsh: data.ywlsh || '',
        bgdd: data.bgdd || '',
        ssxmName: data.xmmc || '',
        ssxmCode: data.xmbh || '',
        jkje: data.jkje || 0,
        isDk: data.isDk || '0',
        dkje: data.dkje || 0,
        bxDkStatus: data.bxDkStatus || '01',
        examineBxAmt: data.examineBxAmt
      };

      // 设置行程明细列表
      this.clbxXcList = data.clbxXcList || [];
      // 设置住宿明细列表
      this.clbxZsList = data.clbxZsList || [];

      // 数据更新后重新绘制连接线
      this.$nextTick(() => {
        setTimeout(() => {
          // this.drawConnectionLines(); // This line is no longer needed as ConnectionLines handles drawing
        }, 300);
      });
    },

    // 预览单个发票（兼容旧接口）
    previewInvoice(invoice) {
      this.previewInvoices(invoice);
    },
    // 统一预览方法：支持单个发票、发票列表、全部发票预览
    async previewInvoices(invoiceData, options = {}) {
      try {
        // 标准化输入数据为发票数组
        const fpList = this.normalizeInvoiceData(invoiceData);

        if (fpList.length === 0) {
          this.$message.warning('没有可预览的发票');
          return;
        }

        // 设置加载状态
        if (options.loadingState) {
          this[options.loadingState] = true;
        }

        // 构建预览文件列表
        const previewFiles = await this.buildPreviewFiles(fpList, options);

        if (previewFiles.length === 0) {
          this.$message.warning('没有可预览的文件');
          return;
        }

        // 执行预览
        this.executePreview(previewFiles);
      } catch (error) {
        console.error('预览发票失败:', error);
        this.$message.error('预览发票失败，请稍后重试');
      } finally {
        // 清除加载状态
        if (options.loadingState) {
          this[options.loadingState] = false;
        }
      }
    },

    // 标准化发票数据为数组格式
    normalizeInvoiceData(invoiceData) {
      if (!invoiceData) return [];

      // 单个发票对象
      if (invoiceData.fpId || invoiceData.fileId) {
        return [invoiceData];
      }

      // 发票数组
      if (Array.isArray(invoiceData)) {
        return invoiceData.filter((invoice) => invoice && (invoice.fpId || invoice.fileId));
      }

      return [];
    },

    // 构建预览文件列表
    async buildPreviewFiles(fpList, options = {}) {
      const previewFiles = [];

      // 如果需要包含行程单（默认包含）
      if (options.includeXcd !== false) {
        const fpIds = fpList.filter((invoice) => invoice.fpId).map((invoice) => invoice.fpId);
        let xcdList = [];

        if (fpIds.length > 0) {
          try {
            xcdList = await this.getXcdByFpIds(fpIds);
          } catch (error) {
            console.warn('获取行程单失败，仅预览发票:', error);
          }
        }

        // 为每个发票添加文件，并紧跟其对应的行程单
        fpList.forEach((invoice) => {
          // 添加发票文件
          if (invoice.fileId) {
            previewFiles.push(
              this.createPreviewFile({
                label: invoice.aliases || invoice.fpName || '发票',
                id: invoice.fileId,
                filename: invoice.aliases || invoice.fpName
              })
            );
          }

          // 查找并添加对应的行程单
          if (invoice.fpId && xcdList && xcdList.length > 0) {
            const correspondingXcds = xcdList.filter((xcd) => xcd.fpid === invoice.fpId);

            correspondingXcds.forEach((xcd) => {
              if (xcd.fileId) {
                previewFiles.push(
                  this.createPreviewFile({
                    label: xcd.fileName,
                    id: xcd.fileId,
                    filename: xcd.fileName
                  })
                );
              }
            });
          }
        });
      } else {
        // 如果不包含行程单，只添加发票文件
        fpList.forEach((invoice) => {
          if (invoice.fileId) {
            previewFiles.push(
              this.createPreviewFile({
                label: invoice.aliases || invoice.fpName || '发票',
                id: invoice.fileId,
                filename: invoice.aliases || invoice.fpName
              })
            );
          }
        });
      }

      return previewFiles;
    },

    // 创建预览文件对象
    createPreviewFile({ label, id, filename }) {
      return {
        label,
        id,
        url:
          this.getGlobalConfig().uploadURL +
          '/api/file/downloadFile' +
          '?fullfilename=' +
          id +
          this.getFileExtensionWithDot(filename) +
          '&fileHashOrWholeFileId=' +
          id
      };
    },

    // 执行预览操作的公共方法
    executePreview(previewFiles) {
      if (previewFiles.length === 0) {
        this.$message.warning('没有可预览的文件');
        return;
      }

      // 设置预览文件数据到 sessionStorage
      window.sessionStorage.previewFileData = JSON.stringify(previewFiles);

      // 左侧配置项 同elementUI tree组件
      window.sessionStorage.defaultProps = JSON.stringify({
        children: 'children',
        label: 'label'
      });

      // 当前高亮的文件（默认第一个）
      window.sessionStorage.currentFile = previewFiles[0].id;

      // 打开预览页面
      window.open(
        window.location.origin +
          (window.location.pathname ? window.location.pathname : '') +
          '#/previewFile?timestamp=' +
          new Date().getTime()
      );
    },

    // 批量预览发票（兼容旧接口）
    previewAllInvoices(fpList) {
      this.previewInvoices(fpList);
    },

    // 根据发票ID获取行程单信息
    getXcdByFpIds(fpIds) {
      // 参数校验
      if (!fpIds || (Array.isArray(fpIds) && fpIds.length === 0)) {
        this.$message.warning('发票ID不能为空');
        return Promise.reject(new Error('发票ID不能为空'));
      }

      // 统一处理为数组格式
      const fpIdArray = Array.isArray(fpIds) ? fpIds : [fpIds];

      // 过滤掉空值
      const validFpIds = fpIdArray.filter((id) => id && id.toString().trim());

      if (validFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return Promise.reject(new Error('没有有效的发票ID'));
      }

      const params = {
        fpIds: validFpIds
      };

      return this.$api
        .formPost('/api/major/fpgl/xcd/doGetByFpId', params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            return res.retBody || [];
          } else {
            const errorMsg = res?.retHead?.message || '获取行程单失败';
            console.error('获取行程单失败:', errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        })
        .catch((error) => {
          console.error('获取行程单请求失败:', error);
          return Promise.reject(error);
        });
    },

    // 显示行程明细详情
    showXcDetail(row) {
      this.currentXcDetail = { ...row };
      this.xcDialogVisible = true;
    },

    // 显示住宿明细详情
    showZsDetail(row) {
      this.currentZsDetail = { ...row };
      this.zsDialogVisible = true;
    },

    // 获取表单数据
    getData() {
      let params = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.clbxXcList.length === 0) {
            this.$message.error('请至少添加一条行程明细');
            return;
          }

          // 验证行程明细数据
          for (let i = 0; i < this.clbxXcList.length; i++) {
            const detail = this.clbxXcList[i];
            if (!detail.fpList || detail.fpList.length === 0) {
              this.$message.error(`第${i + 1}条行程明细的发票数量不能为0`);
              return;
            }
          }

          params = JSON.parse(
            JSON.stringify({
              ...this.form,
              clbxXcList: this.clbxXcList,
              clbxZsList: this.clbxZsList // Added clbxZsList to params
            })
          );
        }
      });

      console.log('clbxApproveForm data:', params);
      return params;
    },

    // 验证表单
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            reject(new Error('表单验证失败'));
          }
        });
      });
    },

    // 重置表单
    resetForm() {
      this.form = {
        clbxUserName: this.form.clbxUserName,
        clbxDate: dayjs().format('YYYY-MM-DD'),
        organCode: this.form.organCode,
        organName: this.form.organName,
        isJd: '0',
        jdOrganCode: '',
        jdOrganName: '',
        xmbh: '',
        xmmc: '',
        bxAmt: 0,
        hzbxAmt: 0,
        isPm: '0',
        pmId: '',
        pmName: '',
        ywlsh: '',
        bgdd: '',
        ssxmName: '',
        ssxmCode: '',
        jkje: 0,
        isDk: '0',
        dkje: 0,
        bxDkStatus: '01'
      };
      this.clbxXcList = [];
      this.clbxZsList = []; // Reset clbxZsList
    },

    // 获取行程明细表格行样式
    getDetailRowClass({ row, rowIndex }) {
      return `detail-${rowIndex}`;
    },

    // 获取发票内容表格行样式
    getInvoiceRowClass({ row, rowIndex }) {
      // 使用发票所属的明细索引来确定颜色
      return `detail-${row.detailIndex}`;
    },

    // 获取住宿情况名称
    getZsqkName(value) {
      const zsqkMap = {
        1: '酒店',
        2: '项目组',
        3: '其他'
      };
      return zsqkMap[value] || value;
    },
    // 计算发票总金额
    calculateInvoiceTotalAmount(fpList) {
      if (!fpList || fpList.length === 0) {
        return 0;
      }
      return fpList.reduce(
        (sum, invoice) => new BigDecimal(sum).add(new BigDecimal(invoice.fpAmt)).value * 1,
        0
      );
    },
    // 计算每个行程记录的总金额
    sumTotalAmt(row) {
      const airAmt = parseFloat(row.airAmt || 0);
      const trainAmt = parseFloat(row.trainAmt || 0);
      const otherAmt = parseFloat(row.otherAmt || 0);
      const inCityAmt = parseFloat(row.examineInCityAmt || row.inCityAmt || 0);
      const btAmt = parseFloat(row.examineBtAmt || row.btAmt || 0);

      // 使用 toFixed(2) 确保浮点精确计算到小数点后两位
      const total = (airAmt + trainAmt + otherAmt + inCityAmt + btAmt).toFixed(2);
      return parseFloat(total);
    },

    // 行程明细合计方法
    getXcSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        // 天数列合计
        if (column.property === 'xcTs') {
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.xcTs);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum;
        } else if (column.property === 'airAmt') {
          // 飞机费用列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.airAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'trainAmt') {
          // 火车费用列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.trainAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'otherAmt') {
          // 其他费用列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.otherAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'inCityAmt') {
          // 市内交通费列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.inCityAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'examineInCityAmt') {
          // 核准市内交通费列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.examineInCityAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'btAmt') {
          // 补贴列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.btAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'examineBtAmt') {
          // 核准补贴列合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.examineBtAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else if (column.property === 'fpList') {
          // 发票总金额列合计

          let totalInvoiceAmt = new BigDecimal('0');
          data.forEach((item) => {
            if (item.fpList && item.fpList.length > 0) {
              item.fpList.forEach((fp) => {
                totalInvoiceAmt = totalInvoiceAmt.add(new BigDecimal(String(fp.fpAmt)));
              });
            }
          });
          sums[index] = totalInvoiceAmt.value * 1;
        } else if (column.property === 'totalAmt') {
          // 总金额列合计
          const sum = data.reduce((prev, curr) => {
            const totalAmt = this.sumTotalAmt(curr);
            return prev + totalAmt;
          }, 0);
          sums[index] = sum.toFixed(2) + '';
        } else {
          // 其他列不合计
          sums[index] = '';
        }
      });
      return sums;
    },

    // 住宿明细合计方法
    getZsSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        // 住宿天数合计
        if (column.property === 'zsTs') {
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.zsTs);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum;
        } else if (column.property === 'zsAmt') {
          // 住宿金额合计
          const sum = data.reduce((prev, curr) => {
            const value = Number(curr.zsAmt);
            if (!isNaN(value)) {
              return prev + value;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toFixed(2);
        } else if (column.property === 'zsPrice') {
          // 单价不合计，显示空
          sums[index] = '';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 预览行程明细的全部发票
    previewAllXcInvoices() {
      if (this.clbxXcList.length === 0) {
        this.$message.warning('没有行程明细数据');
        return;
      }

      // 收集所有行程明细的发票
      const allFpList = [];
      this.clbxXcList.forEach((detail) => {
        if (detail.fpList && detail.fpList.length > 0) {
          allFpList.push(...detail.fpList);
        }
      });

      this.previewInvoices(allFpList, {
        loadingState: 'previewingXc'
      });
    },

    // 预览住宿明细的全部发票
    previewAllZsInvoices() {
      if (this.clbxZsList.length === 0) {
        this.$message.warning('没有住宿明细数据');
        return;
      }

      // 收集所有住宿明细的发票
      const allFpList = [];
      this.clbxZsList.forEach((detail) => {
        if (detail.fpList && detail.fpList.length > 0) {
          allFpList.push(...detail.fpList);
        }
      });

      this.previewInvoices(allFpList, {
        loadingState: 'previewingZs'
      });
    },

    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      // 处理日期格式 "2025-01-07 00:00:00" -> "2025-01-07"
      return dateStr.split(' ')[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.el-divider__text {
  color: #409eff !important;
  font-weight: bold;
  font-size: 16px;
}

.pctw100 {
  width: 100%;
}

.el-form-item {
  margin-bottom: 10px;
}

.el-row {
  margin-bottom: 10px;
}

// 调整分割线上下间距
::v-deep .el-divider--horizontal {
  margin: 12px 0;
}

// 添加展开/收起按钮的样式（已废弃，现在使用折叠面板）
.collapse-toggle {
  font-size: 14px;
  margin-left: 10px;
  color: #409eff;
  cursor: pointer;
}

.collapse-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.collapse-title {
  color: #409eff !important;
  font-weight: bold;
  font-size: 16px;
  margin-left: 35px;
}

.collapse-actions {
  margin-right: 20px;

  .el-button--text {
    color: #409eff;
    font-size: 12px;
    padding: 0;

    &:hover {
      color: #66b1ff;
    }

    &:disabled {
      color: #c0c4cc;
    }
  }
}

// 调整折叠面板样式
::v-deep .el-collapse {
  border-top: none;
  border-bottom: none;
}

::v-deep .el-collapse-item__header {
  background-color: transparent;
  border-bottom: 1px solid #ebeef5;
  height: 48px;
  line-height: 48px;
}

::v-deep .el-collapse-item__content {
  padding: 10px 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #606266;
}

::v-deep .el-select.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #606266;
}

/* 确保表格单元格的背景色不被覆盖 */
::v-deep .el-table__body tr.detail-0 td.el-table__cell {
  background-color: #e5eeff !important;
}

::v-deep .el-table__body tr.detail-1 td.el-table__cell {
  background-color: #fff3e8 !important;
}

::v-deep .el-table__body tr.detail-2 td.el-table__cell {
  background-color: #fce5e5 !important;
}

::v-deep .el-table__body tr.detail-3 td.el-table__cell {
  background-color: #e5eeff !important;
}

::v-deep .el-table__body tr.detail-4 td.el-table__cell {
  background-color: #fff3e8 !important;
}

.tables-container {
  width: 100%;
  margin: 0 -20px;
  padding: 0 20px;
  min-height: calc(100vh - 400px);
  display: flex;
  flex-direction: column;
}

.content {
  width: 100%;
  padding: 10px;
  height: calc(100% - 70px);
  display: flex;
  justify-content: space-between;
  overflow: auto;
}

.content-box {
  width: 14px;
  flex-grow: 1;
  height: 100%;
}

.content-box-title {
  width: 100%;
  font-family: PingFang SC;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: normal;
  color: #767676;
}

.content-box-title-weight {
  font-weight: 700;
  color: #1a1a1a;
}

.content-box-table {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  padding: 10px 0px 0;
  background: #f8fafd;
}

/* 新增PDF预览相关样式 */
.pdf-container {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.pdf-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #909399;
}

.pdf-loading p {
  margin-top: 10px;
}

/* 核准报销金额样式 */
.examine-bt-amt {
  ::v-deep .el-form-item__label {
    color: #e6a23c !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  ::v-deep .jh-number {
    border: 2px solid #e6a23c !important;
    border-radius: 4px;
    background-color: #fdf6ec !important;
  }

  ::v-deep .el-input__inner {
    background-color: #fdf6ec !important;
    border-color: #e6a23c !important;
    color: #e6a23c !important;
    font-weight: bold !important;
  }

  ::v-deep .el-input-group__append {
    background-color: #e6a23c !important;
    color: white !important;
    border-color: #e6a23c !important;
    font-weight: bold !important;
  }
}

/* 报销金额醒目样式 */
.examine-incity-amt {
  ::v-deep .el-form-item__label {
    color: #67c23a !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  ::v-deep .jh-number {
    border: 2px solid #67c23a !important;
    border-radius: 4px;
    background-color: #f0f9ff !important;
  }

  ::v-deep .el-input__inner {
    background-color: #f0f9ff !important;
    border-color: #67c23a !important;
    color: #67c23a !important;
    font-weight: bold !important;
  }

  ::v-deep .el-input-group__append {
    background-color: #67c23a !important;
    color: white !important;
    border-color: #67c23a !important;
    font-weight: bold !important;
  }
}
</style>
